import BatteryDefault from "../default/BatteryDefault";
import Design from "../../../ui/design";

export default class BatteryImages extends BatteryDefault {
    public checkRequirements(): boolean {
        if (window.innerWidth >= Design.BC.md && window.innerHeight > 575) {
            console.log(`customForm-Battery-images: This form is disabled for large screen.`);
            return false;
        }

        return true;
    }
}
